<template>
  <v-data-table
      :headers="headers"
      :items="filteredList"
      :options.sync="localOptions"
      :search="search"
      :mobile-breakpoint="mobileBreakpoint"
  >
    <template v-slot:[`body.prepend`]="props">
      <tr>
        <th
            v-for="header in props.headers"
            :key="header.text"
        >
          <div v-if="filters.hasOwnProperty(header.value)">
            <v-select
                v-model="filters[header.value]"
                :items="columnValueList(header.value)"
                placeholder="Filtro"
                multiple
                clearable
                hide-details
                class="caption"
                style="padding-top: 0"
            >
              <template v-slot:selection="{ index }">
                <span
                    v-if="index === 0"
                    class="grey--text caption"
                >
                  {{ filters[header.value].length }}
                  {{ filters[header.value].length === 1 ? 'item' : 'items' }}
                </span>
              </template>
            </v-select>
          </div>
        </th>
      </tr>
    </template>

    <template v-slot:item="props">
      <slot name="item" v-bind:item="props.item">
        <td v-for="header in headers" :key="header.value">
          {{ getDescendantProp(props.item, header.value) }}
        </td>
      </slot>
    </template>

    <template v-slot:[`body.append`]="props">
      <slot name="body.append" :filteredList="filteredList" :items="props.items"/>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'FhDataTable',
    props: {
      'search': String,
      'headers': Array,
      'options': Object,
      'items': Array,
      'mobileBreakpoint': Number,
    },
    data() {
      return {
        filters: {},
        localOptions: {},
      }
    },
    watch: {
      localOptions: function (value) {
        this.$emit('update:options', value)
      },
    },
    computed: {
      filteredList() {
        return this.items.filter(item => {
          return Object.keys(this.filters).every(filter => {
            return this.filters[filter].length < 1 || this.filters[filter].includes(this.getDescendantProp(item, filter))
          })
        })
      }
    },
    methods: {
      columnValueList(val) {
        return this.items.map(item => this.getDescendantProp(item, val))
      },
      getDescendantProp(object, dotNotationDescendant) {
        return dotNotationDescendant.split('.').reduce((a, b) => a[b], object)
      }
    },
    created() {
      // Initialize filter for every header that does not have the prop filterable = false
      this.headers.forEach((header) => {
        if (header.filterable !== false) {
          this.$set(this.filters, header.value, [])
        }
      })

      this.localOptions = this.options
    }
  }
</script>

<style scoped>

</style>
